module.exports = __webpack_public_path__ + "assets/img/mini.a43a8145.png";